// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".attach .upload-cover {\n  margin-top: -5px !important;\n}\n.attach .upload-cover .custom-upload, .attach .upload-cover .uploaded-file-list {\n  min-height: 300px !important;\n  max-height: 300px !important;\n}", ""]);
// Exports
module.exports = exports;
